import ChargingStationContainer from 'containers/ChargingStation/index'
import React from 'react'

const ChargingStation = () => {
  return (
    <div><ChargingStationContainer/></div>
  )
}

export default ChargingStation